import { compose, Fields, hako } from '@hako/core'
import { Layout } from '@/components/Layout'
import { ProductFeaturesList } from '@/pages/products/components/features/ProductFeatureList'
import { SpecList } from '@/pages/products/components/specification/SpecList'
import { fetchProduct } from '@/modules/products/ssr/fetchProduct'
import { ProductProvider } from '@/pages/products/ProductProvider'
import { BuySection } from './components/buy-section'
import { HatchProvider } from '@/modules/hatch/HatchProvider'
import { Video } from '@/pages/products/components/Video'

const ProductPage = ({ product }) => {
    // TMP
    const fake_software_and_drivers = [
        {
            title: 'Smart Control Software',
            description: 'Version 1.0.0\nZIP file, 134.5 MB\n31 January 2023',
            link: '#',
        },
        {
            title: 'Smart Control Software',
            description: 'Version 1.0.0\nZIP file, 134.5 MB\n31 January 2023',
            link: '#',
        },
        {
            title: 'Smart Control Software',
            description: 'Version 1.0.0\nZIP file, 134.5 MB\n31 January 2023',
            link: '#',
        },
        {
            title: 'Smart Control Software',
            description: 'Version 1.0.0\nZIP file, 134.5 MB\n31 January 2023',
            link: '#',
        },
    ]
    //product.drivers = fake_software_and_drivers

    const driversColumns =
        product?.drivers && product?.drivers?.length <= 12
            ? product?.drivers?.length
            : 12

    return (
        <ProductProvider product={product}>
            <HatchProvider
                productId={product.external_id}
                affiliateId={product.hatch.affiliateId}
                countryCode={product.hatch.countryCode}
            >
                <Layout theme={product.theme}>
                    <section className="section hero grid">
                        <div className="grid-container">
                            <Fields.Text
                                as="span"
                                className="paragraph u-text-highlight"
                                slug="product-pre-title"
                            >
                                {product.description}
                            </Fields.Text>

                            <h1 className="h4 u-margin-top-small u-margin-bottom-small">
                                {product.name}
                            </h1>

                            <div className="hero__image-wrapper">
                                <img
                                    className="hero__image"
                                    src={product.images.IMS}
                                    alt={product.name}
                                />
                                <Fields.Text
                                    as="h2"
                                    slug="product-slogan"
                                    className="hero__slogan"
                                >
                                    Gaming beyond innovation
                                </Fields.Text>
                            </div>
                        </div>
                    </section>

                    {product?.video_url && (
                        <Video
                            url={product.video_url}
                            smaller={product.name === '34M2C8600'}
                        />
                    )}

                    <Fields.Group
                        slug="product-block-group-1-awards"
                        className="section section--dark people grid u-mobile-order--reverse"
                        as="section"
                        defaultTranslatableAttributes={{
                            hidden: true,
                        }}
                        translatableVisibility
                        scope="local"
                    >
                        <div className="grid-column-start-1 grid-column-end-7 grid-column-tablet-start-1 grid-column-tablet-end-5 grid-column-mobile-start-1 grid-column-mobile-end-5 u-justify-self-center">
                            <Fields.Image
                                src="/images/placeholder.webp"
                                alt=""
                                className=""
                                slug="product-block-7-image"
                                translatable
                            ></Fields.Image>
                        </div>
                        <div className="grid-column-start-8 grid-column-end-11 grid-column-tablet-start-5 grid-column-tablet-end-9 grid-column-mobile-start-1 grid-column-mobile-end-5">
                            <Fields.Text slug="product-block-7-text">
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit. Quisque fermentum rutrum
                                vulputate. Curabitur interdum, ipsum sit amet
                                volutpat auctor, lorem lorem accumsan ante,
                                convallis fermentum felis justo ut dolor.
                                Aliquam in nisi ipsum. Fusce mi dolor, posuere
                                in nisi a, fringilla sodales elit. Maecenas
                                iaculis ut quam a hendrerit. Donec a libero eget
                                justo accumsan hendrerit. Curabitur a diam
                                sodales, rhoncus tellus id, pharetra augue.
                                Curabitur feugiat fermentum ex in fringilla.
                            </Fields.Text>
                        </div>
                    </Fields.Group>

                    <section className="section section--dark people grid u-mobile-order--reverse">
                        <Fields.Background
                            slug="product-block-1-image"
                            className="grid-column-start-1 grid-column-end-7 grid-column-tablet-start-1 grid-column-tablet-end-5 grid-column-mobile-start-1 grid-column-mobile-end-5 people-image"
                            src={product.images['section-2']}
                        ></Fields.Background>
                        <div className="grid-column-start-8 grid-column-end-11 grid-column-tablet-start-5 grid-column-tablet-end-9 grid-column-mobile-start-1 grid-column-mobile-end-5">
                            <div className="circle-shadow"></div>
                            <Fields.Text
                                slug="product-block-1-text"
                                style={{ fontSize: '1.5rem' }}
                            >
                                Evnia brings you the optimal gaming experience.
                                There’s always a way to enjoy your game.
                            </Fields.Text>
                        </div>
                    </section>

                    <section className="section grid">
                        <div className="grid-container grid">
                            <div className="grid-column-start-1 grid-column-end-7 grid-column-tablet-start-1 grid-column-tablet-end-5 grid-column-mobile-start-1 grid-column-mobile-end-5">
                                <Fields.Image
                                    src={product.images['section-3']}
                                    alt=""
                                    className="u-image-full"
                                    slug="product-block-2-image-people"
                                />
                                <Fields.Text
                                    as="p"
                                    className="h3 highlight-text u-padding-top-medium"
                                    slug="product-block-2-text"
                                >
                                    {
                                        "Find what makes you unique with Evnia's gaming monitor and play with style."
                                    }
                                </Fields.Text>
                            </div>
                            <div className="grid-column-start-7 grid-column-end-13 grid-column-tablet-start-5 grid-column-tablet-end-9 grid-column-mobile-start-1 grid-column-mobile-end-5 u-padding-top-medium">
                                <img src={product.images.A2P} alt="" />
                            </div>
                        </div>
                    </section>

                    <section className="section section--animation u-padding-top-none u-padding-bottom-none">
                        <div className="grid-container grid u-align-items-center">
                            <div className="grid-column-start-3 grid-column-end-6 grid-column-tablet-start-1 grid-column-tablet-end-5 grid-column-mobile-start-1 grid-column-mobile-end-5">
                                <Fields.Text
                                    className="h3 highlight-text u-padding-top-xlarge"
                                    slug="product-block-6-text"
                                >
                                    Ambiglow creates this magic environment that
                                    makes your interior a part of the game.
                                </Fields.Text>
                            </div>
                            <div className="grid-column-start-6 grid-column-end-13 grid-column-tablet-start-5 grid-column-tablet-end-9 grid-column-mobile-start-1 grid-column-mobile-end-5 u-padding-top-medium">
                                <Fields.Image
                                    src={product.images['left-back']}
                                    alt=""
                                    className="u-image-full animate"
                                    slug="product-block-6-image-animation"
                                />
                            </div>
                        </div>
                    </section>

                    <section className="section u-padding-bottom-none">
                        <div className="grid grid-container">
                            <div className="u-desktop-text-center grid-center--8col">
                                <Fields.Text
                                    as="h2"
                                    className="h2"
                                    slug="product-block-3-title"
                                >
                                    A beautiful addition
                                </Fields.Text>

                                <Fields.Text
                                    as="p"
                                    className="h4 highlight-text"
                                    slug="product-block-3-subtitle"
                                >
                                    Sustainable monitor stand Not your typical
                                    gaming design
                                </Fields.Text>
                            </div>
                        </div>
                        <div className="grid-column-start-1 grid-column-end-13 grid u-margin-top-xxlarge u-image-bg">
                            <div className="grid-container">
                                <img
                                    src={product.images.IMS}
                                    alt=""
                                    className="u-image-full"
                                />
                            </div>
                        </div>
                    </section>

                    <section className="section section--floating section--gray grid u-padding-top-xxlarge">
                        <div className="grid-container grid u-align-items-center u-mobile-order--reverse">
                            <div className="grid-column-start-1 grid-column-end-7 grid-column-tablet-start-1 grid-column-tablet-end-5 grid-column-mobile-start-1 grid-column-mobile-end-5">
                                <Fields.Image
                                    src={product.images['left-front']}
                                    alt=""
                                    className="u-image-full"
                                    slug="product-block-4-image"
                                />
                            </div>
                            <div className="grid-column-start-8 grid-column-end-13 grid-column-tablet-start-5 grid-column-tablet-end-9 grid-column-mobile-start-1 grid-column-mobile-end-5">
                                <Fields.Text
                                    as="p"
                                    className="h4 highlight-text u-padding-top-small u-padding-bottom-xlarge"
                                    slug="product-block-4-text"
                                >
                                    Moldability and Modernity at its Finest. The
                                    sleek and smooth aesthetic of our monitors
                                    is sure to fit into any home design.
                                </Fields.Text>
                            </div>
                        </div>
                    </section>

                    <ProductFeaturesList items={product.features} />

                    <section className="section section--dark grid u-padding-top-none">
                        <div className="grid-column-start-3 grid-column-end-6  grid-column-tablet-start-1 grid-column-tablet-end-5 grid-column-mobile-start-1 grid-column-mobile-end-5 u-padding-top-xlarge u-padding-bottom-large">
                            <Fields.Text
                                as="p"
                                className="h4 highlight-text highlight-text--blend"
                                slug="product-block-5-title"
                            >
                                {"It's not about being the best."}
                            </Fields.Text>
                            <br />
                            <Fields.Text slug="product-block-5-text">
                                It is time for you. In a different world but on
                                your terms.
                            </Fields.Text>
                            <br />
                            <div className="u-full u-margin-top-medium u-margin-bottom-medium">
                                <Fields.Link
                                    href="/manifesto"
                                    className="btn btn--secondary btn--dark btn--full-mobile"
                                    slug="product-see-manifesto-button"
                                >
                                    See our manifesto
                                </Fields.Link>
                            </div>
                        </div>
                        <div className="grid-column-start-7 grid-column-end-13  grid-column-tablet-start-5 grid-column-tablet-end-9 grid-column-mobile-start-1 grid-column-mobile-end-5">
                            <Fields.Image
                                src="/images/people2.webp"
                                alt=""
                                className="u-image-full"
                                slug="product-block-5-image"
                            />
                        </div>
                    </section>

                    <section className="section section--dark grid u-padding-bottom-none">
                        <div className="grid-container">
                            <Fields.Text
                                as="h2"
                                className="h2 u-txt-light-primary u-margin-bottom-small"
                                slug="product-technical-specification-header"
                            >
                                Technical specifications
                            </Fields.Text>

                            <SpecList items={product.specs} />
                        </div>
                    </section>

                    <section className="section section--dark grid grid--boxed u-padding-bottom-none">
                        <div className="grid-container">
                            <picture className="u-image-glow u-image-cutted">
                                <img
                                    src={product.images.A1P}
                                    alt=""
                                    className="u-image-full"
                                />
                            </picture>
                        </div>
                    </section>

                    <BuySection />

                    {!!product?.drivers?.length && (
                        <section className="section grid">
                            <div className="grid-container">
                                <Fields.Text
                                    as="h2"
                                    className="h2 u-txt-light-primary u-margin-bottom-small"
                                    slug="product-software-and-drivers-header"
                                >
                                    Software and drivers
                                </Fields.Text>
                                <div className="row u-margin-bottom-medium columns-4">
                                    <div className="input-group">
                                        <label htmlFor="select-language">
                                            Language
                                        </label>
                                        <select
                                            id="select-language"
                                            className="select"
                                        >
                                            <option disabled>
                                                Select a language
                                            </option>
                                            <option>English (US)</option>
                                            <option>Polish</option>
                                        </select>
                                    </div>
                                </div>
                                <div
                                    className={`row columns-${driversColumns} row-gap-small`}
                                >
                                    {product.drivers.map((item, index) => (
                                        <div className="box" key={index}>
                                            <div className="box__content">
                                                <span>{item.title}</span>
                                                <div className="box__highlight">
                                                    <span>
                                                        {item.description}
                                                    </span>
                                                </div>
                                                <a
                                                    href={item.link}
                                                    target="_blank"
                                                    rel="noreferrer nofollow"
                                                >
                                                    <button className="btn btn--primary btn--light btn--full">
                                                        <Fields.Text
                                                            editable={false}
                                                            as="span"
                                                            scope="global"
                                                            slug="software_drivers_download"
                                                        >
                                                            Download
                                                        </Fields.Text>
                                                    </button>
                                                </a>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </section>
                    )}
                    {!!product?.footnotes?.length && (
                        <section className="section grid">
                            <div className="grid-container u-margin-bottom-medium">
                                <div className="footnotes">
                                    <ul>
                                        {product.footnotes.map(
                                            (item, index) => (
                                                <li key={index}>{item}</li>
                                            )
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </section>
                    )}
                </Layout>
            </HatchProvider>
        </ProductProvider>
    )
}

export default ProductPage
export const getServerSideProps = compose(hako('product', 'slug'), fetchProduct)
